import {
    Box,
    Button,
    Flex,
    HStack,
    Icon,
    IconButton,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Text,
    useDisclosure,
    useToast
} from '@chakra-ui/react'
import Less from 'components/Icon/Less'
import Plus from 'components/Icon/Plus'
import { put } from '../../../../lib/http'
import useOrderByTable from 'pages/QuickSaleBy/hooks/useOrderByTable'
import { useState } from 'react'
import Pencil from '../../../../components/Icon/Pencil'
import Users from 'components/Icon/Users'
import useSession from '../../../../hooks/useSession'
import ModalPin from '../ModalPin'

export default function ModalDiner() {
    const { isOpen, onClose, onOpen } = useDisclosure()
    const [isOpenPin, setIsOpenPin] = useState(false)
    const { setDiners, diners, orderId, pin, setPin } = useOrderByTable()
    const [prevNumber, setPrevNumber] = useState(diners)
    const [isLoading, setIsLoading] = useState(false)
    const toast = useToast()
    const { session } = useSession()

    async function acceptHandler() {
        if (orderId) {
            setIsLoading(true)
            const { error } = await put(`/api/orders/${orderId}/diners`, {
                diners: prevNumber,
                pin: pin || undefined,
                userId: session?.user?.id || undefined
            })
            setIsLoading(false)
            if (error) {
                toast({
                    title: error.message,
                    position: 'top',
                    isClosable: true,
                    status: 'error'
                })
            } else {
                toast({
                    title: 'Comensal actualizado',
                    position: 'top',
                    isClosable: true,
                    status: 'success'
                })
                setDiners(prevNumber)
            }
        } else {
            setDiners(prevNumber)
        }
        onClose()
    }

    function openHandler(_pin?: string) {
        if (_pin) {
            setPin(_pin)
        }
        setPrevNumber(diners)
        onOpen()
    }

    return (
        <>
            <ModalPin
                isOpen={isOpenPin}
                onClose={() => setIsOpenPin(false)}
                onPin={_pin => openHandler(_pin)}
            />
            <input type="hidden" name="diners" value={diners} />
            <HStack w="full" gap={1}>
                <Text textAlign="left" fontSize="sm" lineHeight={'100%'}>
                    Comensales:
                </Text>
                <Button
                    variant="outline"
                    colorScheme="gray"
                    onClick={
                        session?.user || !orderId
                            ? () => openHandler()
                            : () => setIsOpenPin(true)
                    }
                    rightIcon={<Pencil />}
                    size="xs"
                >
                    {diners}
                </Button>
            </HStack>
            <Modal isOpen={isOpen} onClose={onClose} size="xs">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Editar comensales</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Box textAlign="center" mt={4}>
                            <Icon
                                w="36px"
                                h="36px"
                                as={Users}
                                fontSize="xl"
                                fill="gray.400"
                                mb={4}
                            />
                            <Flex
                                alignItems="center"
                                justify="center"
                                mb={6}
                                gap={6}
                            >
                                <IconButton
                                    aria-label="menor"
                                    icon={<Less />}
                                    isDisabled={prevNumber <= 1}
                                    onClick={() =>
                                        setPrevNumber(
                                            prevNumber <= 1 ? 1 : prevNumber - 1
                                        )
                                    }
                                />
                                <Box>
                                    <Text
                                        fontSize="4xl"
                                        fontWeight="bold"
                                        lineHeight="100%"
                                    >
                                        {prevNumber}
                                    </Text>
                                    <Text color="gray.400" fontSize="xs">
                                        comensales
                                    </Text>
                                </Box>
                                <IconButton
                                    aria-label="mas"
                                    icon={<Plus />}
                                    isDisabled={prevNumber >= 99}
                                    onClick={() =>
                                        setPrevNumber(
                                            prevNumber >= 99
                                                ? 99
                                                : prevNumber + 1
                                        )
                                    }
                                />
                            </Flex>
                        </Box>
                    </ModalBody>
                    <ModalFooter gap={2}>
                        <Button onClick={onClose} w="full">
                            Cancelar
                        </Button>
                        <Button
                            w="full"
                            colorScheme="green"
                            isDisabled={prevNumber === 0}
                            onClick={acceptHandler}
                            isLoading={isLoading}
                        >
                            Confirmar
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}
